import { MyDetails } from "../common/types";

export const introDetails: MyDetails = {
	name: "Fattah Salleh",
	position: "SENIOR FRONTEND DEVELOPER",
};

